module.exports = __webpack_public_path__ + "img/login.45386c6e.jpg";